import React from 'react';
import ProductCard from './ProductCard';
import SkeletonCard from './SkeletonCard';
import styles from './ProductGrid.module.scss';

/**
 * Product grid component
 * Displays a grid of product cards, skeleton loaders, or empty/no results state
 *
 * @param {Object} props
 * @param {Array} props.products - Array of products to display
 * @param {boolean} props.isLoading - Whether data is loading
 */
export default function ProductGrid({ products, isLoading }) {
    // Show skeleton loaders while initially loading
    if (isLoading) {
        return (
            <div className={styles.products}>
                {Array.from({ length: 12 }).map((_, index) => (
                    <SkeletonCard key={`skeleton-${index}`} />
                ))}
            </div>
        );
    }

    // Show no results message if no products found
    if (!products || products.length === 0) {
        return (
            <div className={styles.noProducts}>
                <p>
                    Leider konnten mit deinen Suchkriterien keine Produkte gefunden werden.
                </p>
            </div>
        );
    }

    // Render actual product cards
    return (
        <div className={styles.products}>
            {products.map((product) => (
                <ProductCard key={product.id} product={product} />
            ))}
        </div>
    );
}
